// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4fc7b158","453":"260f6c09","732":"290e81e0","977":"9704e2e2"}[chunkId] + ".chunk.js";
};